import type { VisualPromptReviewContext } from '@/components/visualPrompts/steps/VisualPromptReviewStep/types';
import type { VisualPromptAnswers } from '@/types/visualPrompts/visualPrompt.types';

export const buildReviewContext = (
  answers: VisualPromptAnswers,
  workspaceName?: string,
): VisualPromptReviewContext => ({
  workspaceName,
  channel: answers.context ? String(answers.context) : undefined,
  matterRelated: answers.matterRelated
    ? String(answers.matterRelated)
    : undefined,
});
